import AnDIcon from "../../utils/assets/images/SideBar/AnDIcon"
import Cleans from "../../utils/assets/images/SideBar/CleansIcon"
import GuestPurchase from "../../utils/assets/images/SideBar/PurchaseIcon"
import Maintenance from "../../utils/assets/images/SideBar/MaintenanceIcon"
import PropDetails from "../../utils/assets/images/SideBar/PropDetailsIcon"
import CalendarMonthColorIcon from "@/utils/assets/images/AvailabilityCalendar/CalendarMonthColorIcon"

export type TNavItem = {
  icon: () => JSX.Element
  text: string
  tabs?: TNavItem[]
  path?: string
  className?: string // Styles via CSS Modules
}

export const navData: { [key in string]: TNavItem[] } = {
  "Guest Operations": [
    {
      icon: AnDIcon,
      text: "Arrival and Departure ",
      path: "/arrival-departure",
    },
    {
      icon: Cleans,
      text: "Cleaning",
      path: "/cleaning-app",
    },
    {
      icon: GuestPurchase,
      text: "Guest Requests",
      path: "/purchases",
    },
  ],
  "Property Management": [
    {
      icon: Maintenance,
      text: "Maintenance",
      path: "/maintenance-request",
    },
    {
      icon: PropDetails,
      text: "Property Details",
      path: "/property",
    },
    {
      icon: GuestPurchase,
      text: "Services / Setup",
      path: "/admin-additional-services",
    },
  ],
  "": [
    {
      icon: CalendarMonthColorIcon,
      text: "Availability Calendar",
      path: "/availability-calendar",
      className: "AvailabilityCalendar",
    },
  ],
}
